import { useEffect, useRef } from 'react';

interface UseDocumentTitleProps {
	title: string;
	prevailOnUnmount?: boolean;
}
function useDocumentTitle({
	title,
	prevailOnUnmount = false,
}: UseDocumentTitleProps) {
	const defaultTitle = useRef(document.title);

	useEffect(() => {
		document.title = title;
	}, [title]);

	useEffect(
		() => () => {
			if (!prevailOnUnmount) {
				document.title = defaultTitle.current;
			}
		},
		[prevailOnUnmount]
	);
}

export default useDocumentTitle;
